import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, Phone, User, Calendar, DollarSign, FileText } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
export function LoanDetail() {
  const {
    loanId
  } = useParams<{
    loanId: string;
  }>();
  return <div className="min-h-screen bg-slate-50 text-slate-900 font-sans" data-id="element-119">
      <div className="px-6 py-6 max-w-4xl mx-auto" data-id="element-120">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-brand-600 transition-colors mb-6" data-id="element-121">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-122" />
          Back to Retention Center
        </Link>

        <div className="flex items-center gap-3 mb-8" data-id="element-123">
          <div className="w-1.5 h-7 rounded-full bg-accent-500" data-id="element-124" />
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-125">Loan Record</h1>
          <span className="text-sm font-mono text-slate-500" data-id="element-126">ID: {loanId}</span>
        </div>

        <Card data-id="element-127">
          <div className="flex items-center justify-center py-16 text-slate-400" data-id="element-128">
            <div className="text-center space-y-3" data-id="element-129">
              <FileText className="h-12 w-12 mx-auto text-slate-400" data-id="element-130" />
              <p className="text-lg font-medium text-slate-700" data-id="element-131">
                Loan Detail View
              </p>
              <p className="text-sm text-slate-500 max-w-md" data-id="element-132">
                This is where the full loan record would be displayed, including
                borrower information, loan terms, document history, and activity
                timeline.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}